/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_SubtitleInputs */

const cs_blog_subtitle = /** @type {(inputs: Blog_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Články pro web vaší kanceláře — publikujte, aby byly vidět.`)
};

const en_blog_subtitle = /** @type {(inputs: Blog_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articles for your agency website — publish to make them live.`)
};

/**
* | output |
* | --- |
* | "Articles for your agency website — publish to make them live." |
*
* @param {Blog_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_subtitle = /** @type {((inputs?: Blog_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_subtitle(inputs)
	return cs_blog_subtitle(inputs)
});